import * as React from 'react'
import {Field, reduxForm} from 'redux-form'
import { validateSecondPage } from './validate'
import renderField from './Form';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

const renderError = ({meta: {touched, error}}) =>
  touched && error ? <span>{error}</span> : false

const WizardFormSecondPage = props => {
  const {handleSubmit, pristine, previousPage, submitting} = props
  return (
    <div>
      <Card>
        <CardContent style={{padding: 50}}>
          <form onSubmit={handleSubmit}>
            <div style={{display: 'flex', justifyContent:"space-between", marginBottom:10}}>
              <Field style={{width: '48%'}} name="displayName" type="text" component={renderField} label="Name" />
              <Field style={{width: '48%'}} name="role" type="text" component={renderField} label="Role" />
            </div>
            <Field style={{width:'100%', marginBottom:10}} name="phone" type="text" component={renderField} label="Phone" />
            <div style={{paddingTop: 20}}>
              <Button  size="large" onClick={previousPage} style={{marginRight:20}}>
                Previous
              </Button>
              <Button type="submit"   style={{background: '#209cee',color:'#fff'}} size="large" disabled={pristine || submitting}>
                Next
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}

export default reduxForm({
  form: 'wizard', //Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate: validateSecondPage // TODO: possibility of submitting invalid first page with valid second page???
})(WizardFormSecondPage)
